var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "table-responsive" }, [
    _c("table", [
      _c("thead", [
        _c("tr", [
          _c("th", [_vm._v("Descripción")]),
          _vm._v(" "),
          _c("th", [_vm._v("Precio")]),
          _vm._v(" "),
          _c("th", [
            _c("div", [
              _c(
                "button",
                { staticClass: "btn-success", on: { click: _vm.agregar } },
                [
                  _c("i", { staticClass: "fa fa-plus" }),
                  _c("span", [_vm._v("Agregar")])
                ]
              )
            ])
          ])
        ])
      ]),
      _vm._v(" "),
      _c(
        "tbody",
        [
          _vm._l(_vm.modelValue, function(precio, index) {
            return _c("tr", { key: index }, [
              _c("td", [
                _c(
                  "div",
                  { staticClass: "form-field" },
                  [
                    _c(
                      "input-field",
                      {
                        attrs: { id: "descripcion" + index },
                        model: {
                          value: _vm.modelValue[index].descripcion,
                          callback: function($$v) {
                            _vm.$set(_vm.modelValue[index], "descripcion", $$v)
                          },
                          expression: "modelValue[index].descripcion"
                        }
                      },
                      [
                        _vm.errores.hasOwnProperty(
                          "precios." + index + ".descripcion"
                        )
                          ? _c(
                              "span",
                              {
                                staticClass: "helper-text text-danger",
                                attrs: { slot: "helper" },
                                slot: "helper"
                              },
                              [
                                _vm._v(
                                  "\n                                " +
                                    _vm._s(
                                      _vm.errores[
                                        "precios." + index + ".descripcion"
                                      ][0]
                                    ) +
                                    "\n                            "
                                )
                              ]
                            )
                          : _vm._e()
                      ]
                    )
                  ],
                  1
                )
              ]),
              _vm._v(" "),
              _c("td", [
                _c(
                  "div",
                  { staticClass: "form-field" },
                  [
                    _c(
                      "input-field",
                      {
                        attrs: {
                          vMoney: "",
                          format: _vm.money,
                          id: "precio" + index
                        },
                        model: {
                          value: _vm.modelValue[index].precio,
                          callback: function($$v) {
                            _vm.$set(_vm.modelValue[index], "precio", $$v)
                          },
                          expression: "modelValue[index].precio"
                        }
                      },
                      [
                        _vm.errores.hasOwnProperty(
                          "precios." + index + ".precio"
                        )
                          ? _c(
                              "span",
                              {
                                staticClass: "helper-text text-danger",
                                attrs: { slot: "helper" },
                                slot: "helper"
                              },
                              [
                                _vm._v(
                                  "\n                                " +
                                    _vm._s(
                                      _vm.errores[
                                        "precios." + index + ".precio"
                                      ][0]
                                    ) +
                                    "\n                            "
                                )
                              ]
                            )
                          : _vm._e()
                      ]
                    )
                  ],
                  1
                )
              ]),
              _vm._v(" "),
              _c("td", [
                _c("div", [
                  _c(
                    "button",
                    {
                      staticClass: "btn-danger btn--text",
                      on: {
                        click: function($event) {
                          return _vm.eliminar(index)
                        }
                      }
                    },
                    [_c("i", { staticClass: "fa fa-trash" })]
                  )
                ])
              ])
            ])
          }),
          _vm._v(" "),
          _c(
            "tr",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.modelValue.length == 0,
                  expression: "modelValue.length == 0"
                }
              ]
            },
            [_vm._m(0)]
          )
        ],
        2
      )
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("td", { attrs: { colspan: "3" } }, [
      _c("strong", [_vm._v("No se ha agregado precios.")])
    ])
  }
]
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-373a2de4", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-373a2de4","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/forms/mantenimiento/items/Precios.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-373a2de4","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/forms/mantenimiento/items/Precios.vue
// module chunks = 0